import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=5987ce25&"
import script from "./UserEdit.vue?vue&type=script&lang=ts&"
export * from "./UserEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5987ce25')) {
      api.createRecord('5987ce25', component.options)
    } else {
      api.reload('5987ce25', component.options)
    }
    module.hot.accept("./UserEdit.vue?vue&type=template&id=5987ce25&", function () {
      api.rerender('5987ce25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserEdit.vue"
export default component.exports